import { PERSONALISATION_STATUS_LABELS } from 'shop/constants/eticketFixes.constants'

export const PERSONALISATION_STATUS = {
  unassigned: 'unassigned',
  pending: 'pending',
  // Separate from `sent`: do not show "sent" for an invitation the mail system has not confirmed.
  queued: 'queued',
  sent: 'sent',
  personalised: 'personalised',
  transferred: 'transferred',
} as const

export type PersonalisationStatus = (typeof PERSONALISATION_STATUS)[keyof typeof PERSONALISATION_STATUS]

// Fallback when the backend omits the status, so a badge never renders a raw i18n key.
export const DEFAULT_PERSONALISATION_STATUS = PERSONALISATION_STATUS.unassigned

// What a seat READS as: shorter than what it stores, since `pending` shows under
// `unassigned` and `queued` under `sent`. Shared by the payer's manage table and the
// seller's e-ticket list so the two cannot offer different words.
//
// Mirrors the backend's PERSONALISATION_DISPLAY_GROUPS plus `transferred`, NOT its
// PERSONALISATION_DISPLAY_STATUSES, which also accepts the folded-away values.
export const PERSONALISATION_DISPLAY_STATUSES: PersonalisationStatus[] = [
  PERSONALISATION_STATUS.unassigned,
  PERSONALISATION_STATUS.sent,
  PERSONALISATION_STATUS.personalised,
  PERSONALISATION_STATUS.transferred,
]

// A function, not a constant: I18n has no locale yet while this module evaluates.
export const getPersonalisationStatusOptions = (): Array<{ value: PersonalisationStatus; label: string }> =>
  PERSONALISATION_DISPLAY_STATUSES.map((status) => ({
    value: status,
    label: PERSONALISATION_STATUS_LABELS[status],
  }))

export type TicketState = 'unused' | 'used' | 'expired' | 'refunded' | 'invalidated'

export const ACTIONABLE_TICKET_STATE: TicketState = 'unused'

export const isTicketStateActionable = (ticketState?: TicketState | null): boolean =>
  ticketState == null || ticketState === ACTIONABLE_TICKET_STATE
